import * as React from 'react';
import * as Core from 'components/core';
import { DocPage } from 'types/docs';
type Props = {
  productVersion: string;
  currentPageTags: Array<string>;
  currentPagePath: string;
};
type State = {
  loadingSearchIndex: boolean;
  unmounted: boolean;
  relatedDocs: Array<DocPage> | undefined | null;
}; // module-level variable, so we don't have to refetch
// if the Search component is destroyed
let searchIndex: Array<DocPage> | undefined | null = null;
export default class RelatedDocs extends React.Component<Props, State> {
  unmounted: boolean = false;
  componentWillUnmount() {
    this.unmounted = true;
  }
  state = {
    results: [],
    unmounted: false,
    loadingSearchIndex: false,
    relatedDocs: null,
  };
  componentDidMount() {
    this.setRelatedDocs();
  }
  setRelatedDocs = () => {
    if (this.unmounted) {
      return;
    }
    if (searchIndex == null) {
      this.setState({
        loadingSearchIndex: true,
      });

      // This is built in gatsby-node.js onPostBuild.
      // To refresh this, restart the development server, or run `yarn build`
      fetch(`/search-index.json`)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          searchIndex = data;
          this.setState({
            loadingSearchIndex: false,
          });
          this.setRelatedDocs();
        });
      return;
    }
    const { currentPageTags, currentPagePath, productVersion } = this.props;
    const relatedDocs = searchIndex.filter((docPage) => {
      return (
        currentPageTags.some((tag) => (docPage.tags || []).includes(tag)) &&
        docPage.productVersion === productVersion &&
        currentPagePath !== docPage.path &&
        currentPagePath !== `${docPage.path}/`
      );
    });
    this.setState({
      relatedDocs,
    });
  };
  render() {
    const { relatedDocs, loadingSearchIndex } = this.state;
    if (loadingSearchIndex || relatedDocs == null || relatedDocs.length === 0) {
      return null;
    }
    return (
      <div className="DocsPage-relatedLinks">
        <div className="DocsPage-relatedLinks-heading">Related Pages</div>

        {relatedDocs.map((docPage) => (
          <div className="DocsPage-relatedLinks-sharesTag" key={docPage.path}>
            <Core.Link to={docPage.path}>{docPage.title}</Core.Link>
          </div>
        ))}
      </div>
    );
  }
}
